<template>
  <div>
    <el-card shadow="hover">
      <div style="padding: 10px">
        <x-table
          listApi="biz.customer.role.info.list"
          paginationLayout="total, sizes, prev, next, jumper"
          emptyLabel="暂无角色信息"
          actionFixed="right"
          :btnList="btnList"
          :defaultParams="defaultParams"
          :fieldList="fieldList"
          :actionList="actionList"
          :paramList="paramList"
          :actionWidth="100"
        >
        </x-table>
      </div>
    </el-card>
  </div>
</template>

<script>
import formPage from './form.vue';

export default {
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    defaultParams() {
      return {
        customerGuid: this.pageParams.customerGuid
      };
    },
    pageParams() {
      return Object.assign(
        {},
        (this.$route && this.$route.params) || {},
        this.params
      );
    },
    pageQuery() {
      return Object.assign(
        {},
        (this.$route && this.$route.query) || {},
        this.query
      );
    },
  },
  data() {
    return {
      paramList: [
      ],
      fieldList: [
        {
          label: '角色名称',
          minWidth: '100',
          render: row => row.roleName || '',
        },
      ],
      actionList: [
        {
          label: '编辑',
          show: (row) => {
            if (!this.$hasPower([
              "optSuper"
            ])) {
              return false;
            };
            return true
          },
          click: (row, tag, refresh) => {
            this.$drawer.openDrawer({
              title: '编辑角色信息',
              refresh,
              component: formPage,
              params: {
                guid: row.guid,
              },
            });
          },
        },
        {
          label: '删除',
          linkType: 'danger',
          show: (row) => {
            if (!this.$hasPower([
              "optSuper"
            ])) {
              return false;
            };
            return true
          },
          click: (row, tag, refresh) => {
            this.$confirm('确定删除?', '提示', {
              type: 'warning',
            }).then(() => {
              this.requestApi('biz.customer.role.info.delete', {
                guid: row.guid,
              }, {
                showError: true
              }).then(() => {
                this.success('删除成功');
                this.$drawer.refreshDrawer();
                refresh && refresh();
              });
            });
          },
        },
      ],
      btnList: [
        {
          label: '新增角色',
          type: 'primary',
          show: (row) => {
            if (!this.$hasPower([
              "optSuper"
            ])) {
              return false;
            };
            return true
          },
          click: (row, tag, refresh) => {
            this.$drawer.openDrawer({
              title: '新增角色',
              refresh,
              component: formPage,
              params: this.defaultParams,
            });
          },
        },
      ],
    };
  },
};
</script>